import Vue from 'vue'
import Router from 'vue-router'
import Hmoe from '../views/home.vue'
import Login from '../views/login.vue'
import fillout from '../views/common/edit/fillout.vue'
import check from '../views/common/check/check.vue'
import singleLogin from '@/views/singleLogin/singleLogin.vue'
import RedirectPage from '@/views/singleLogin/RedirectPage.vue'
import login from '../views/login.vue'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
    path:'/login',
      name:'login',
      component:login

    },
    {
      path:'/RedirectPage',
      name:'RedirectPage',
      component: RedirectPage},
    {
      path: "/singleLogin",
      name: "singleLogin",
      component: singleLogin
    },
    {
      path: '/',
      name: 'home',
      component: (resolve) => require(['../views/home.vue'], resolve),
      children:[
        {
          path: '/fillout',
          component:(resolve) => require(['../views/common/edit/fillout.vue'], resolve),
          meta: { title: '月报填报' }
    },
        {
          path: '/check',
          component:(resolve) => require(['../views/common/check/check.vue'], resolve),
          meta: { title: '月报审批' }
        },
      ]
    },
    {
        path: '*',
        name : '404'}
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js